<template>
	<v-card :elevation="1" class="background-2" width="100%">
		<v-card-text>
			<!-- Section Settings: Switch globali -->
			<v-card outlined class="pa-3 mb-4">
				<v-card-title class="text-subtitle-1 pa-0 pb-2">
					Impostazioni Sezione Totali
				</v-card-title>
				<v-divider class="mb-3"></v-divider>

				<v-row>
					<v-col cols="12" md="6">
						<v-switch
							v-model="sectionSettings.hidden"
							label="Nascondi completamente la sezione totali"
							inset
							hide-details
							class="ma-0"
						></v-switch>
					</v-col>
					<v-col cols="12" md="6">
						<v-switch
							v-model="sectionSettings.hidden_for_roles_exclude"
							:label="'Escludi questi ruoli dalla visualizzazione della sezione: ' + (sectionSettings.hidden_for_roles_exclude ? 'Si' : 'No')"
							inset
							hide-details
							class="ma-0 mb-2"
						></v-switch>
						<v-select
							v-model="sectionSettings.hidden_for_roles"
							:items="roles"
							label="Ruoli per visibilità sezione"
							multiple
							dense
							chips
							small-chips
							:menu-props="{'offset-y': true}"
							outlined
							hide-details
							:disabled="sectionSettings.hidden"
						></v-select>
					</v-col>
				</v-row>
			</v-card>

			<v-row class="mx-0">
				<!-- Pannello sinistro: Campi totali configurati -->
				<v-col cols="6" class="pl-0">
					<v-card outlined class="pa-2" style="max-height: 500px; overflow: auto; padding-bottom: 40% !important;">
						<v-card-title class="text-subtitle-1">
							Totali Visibili
						</v-card-title>
						<v-divider class="mb-3"></v-divider>

						<draggable
							v-model="selectedFields"
							:group="{
								name: 'totals-fields',
								pull: true,
								put: function(to, from) {
									return from.options.group.name === 'totals-fields'
								}
							}"
							handle=".drag-handle"
							class="pa-2"
							ghostClass="ghost-element"
							chosenClass="chosen-element"
							:swapThreshold="0.50"
							@change="updateFieldOrder">

							<v-card v-for="field in selectedFields"
								:key="field.key"
								outlined
								class="field-card mb-2">
								<v-row class="ma-0 px-2 py-1">
									<v-col cols="1" class="pa-2 d-flex align-center">
										<v-icon class="drag-handle">mdi-drag-vertical-variant</v-icon>
									</v-col>
									<v-col cols="1" class="pa-2 d-flex align-center">
										<v-icon :color="field.color">{{ field.icon }}</v-icon>
									</v-col>
									<v-col cols="7" class="pa-2 d-flex align-center">
										<span class="drag-handle">{{ field.text }}</span>
									</v-col>
									<v-spacer></v-spacer>
									<v-col cols="1" class="pa-2">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													icon
													small
													@click="removeField(field)"
													color="error"
													v-bind="attrs"
													v-on="on">
													<v-icon>mdi-delete</v-icon>
												</v-btn>
											</template>
											<span>Rimuovi</span>
										</v-tooltip>
									</v-col>

									<v-col cols="1" class="pa-2">
										<v-btn icon small @click="toggleExpand(field)" color="primary">
											<v-icon>{{ isExpanded(field) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
										</v-btn>
									</v-col>
								</v-row>

								<div v-show="isExpanded(field)" class="expand-content">
									<v-divider></v-divider>
									<v-row class="ma-0 pa-2">
										<v-col cols="12" class="pa-2">
											<v-switch
												v-model="field.permissions.show_exclude"
												:label="'Escludi questi ruoli dalla visualizzazione: ' + (field.permissions.show_exclude ? 'Si' : 'No')"
												inset
												hide-details
												class="mb-2 ma-0"
											></v-switch>
											<v-select
												v-model="field.permissions.show"
												:items="roles"
												label="Permessi Visibilità"
												multiple
												dense
												chips
												small-chips
												:menu-props="{'offset-y': true}"
												outlined
												hide-details
												@change="cleanupRolesArray(field.permissions, 'show')"
											></v-select>
										</v-col>
									</v-row>
								</div>
							</v-card>
						</draggable>

						<v-card-actions class="pt-3">
							<v-row no-gutters>
								<v-col cols="6" class="pr-1">
									<v-btn
										block
										color="primary"
										@click="addAllFields"
										:disabled="!availableFields.length">
										<v-icon left>mdi-arrow-all</v-icon>
										Aggiungi tutti
									</v-btn>
								</v-col>
								<v-col cols="6" class="pl-1">
									<v-btn
										block
										color="error"
										@click="clearAllFields"
										:disabled="!selectedFields.length">
										<v-icon left>mdi-delete-sweep</v-icon>
										Svuota tutto
									</v-btn>
								</v-col>
							</v-row>
						</v-card-actions>
					</v-card>
				</v-col>

				<!-- Pannello destro: Campi disponibili -->
				<v-col cols="6" class="pr-0">
					<v-card outlined class="pa-2" style="max-height: 500px; overflow: auto; padding-bottom: 40% !important;">
						<v-card-title class="text-subtitle-1">
							Totali Disponibili
						</v-card-title>
						<v-divider class="mb-3"></v-divider>

						<draggable
							:list="availableFields"
							:group="{
								name: 'totals-fields',
								pull: 'clone',
								put: false,
								revertClone: true
							}"
							:sort="false"
							:clone="cloneField">
							<v-card
								v-for="field in availableFields"
								:key="field.key"
								class="cursor-pointer mb-1"
								outlined>
								<v-card-text class="py-2 d-flex align-center">
									<v-icon class="pr-2 drag-handle" :color="field.color">{{ field.icon }}</v-icon>
									{{ field.text }}
								</v-card-text>
							</v-card>
						</draggable>
					</v-card>
				</v-col>
			</v-row>
		</v-card-text>

		<v-divider></v-divider>

		<v-card-actions class="pa-3">
			<v-spacer></v-spacer>
			<v-btn color="primary" @click="saveConfiguration">
				Salva Configurazione
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import draggable from 'vuedraggable'

export default {
	name: 'FieldsTotalsSelector',
	components: {
		draggable
	},

	props: {
		modelDef: {
			type: String,
			required: true
		},
		allFields: {
			type: Array,
			default: () => []
		},
		configuration: {
			type: Object,
			default: null
		},
		configKey: {
			type: String,
			required: true
		},
		roles: {
			type: Array,
			default: () => []
		},
		mobile: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			selectedFields: [],
			expandedFields: {},
			sectionSettings: {
				hidden: false,
				hidden_for_roles: [],
				hidden_for_roles_exclude: false
			}
		}
	},

	computed: {
		availableFields: {
			get() {
				const usedFieldKeys = new Set(this.selectedFields.map(f => f.key))
				return (this.allFields || []).filter(field => !usedFieldKeys.has(field.key))
			},
			set() {
				// Necessario per il v-model ma non fa nulla
			}
		}
	},

	watch: {
		configuration: {
			immediate: true,
			handler(newConfig) {
				this.loadFromConfiguration(newConfig)
			}
		},
		allFields: {
			immediate: true,
			handler() {
				if (this.configuration) {
					this.loadFromConfiguration(this.configuration)
				}
			}
		}
	},

	methods: {
		loadFromConfiguration(config) {
			if (!this.allFields?.length) return

			// Carica section_settings
			if (config?.section_settings) {
				this.sectionSettings = {
					hidden: config.section_settings.hidden || false,
					hidden_for_roles: config.section_settings.hidden_for_roles || [],
					hidden_for_roles_exclude: config.section_settings.hidden_for_roles_exclude || false
				}
			}

			// Carica campi configurati
			if (config?.fields) {
				this.selectedFields = Object.entries(config.fields)
					.filter(([key]) => {
						return this.allFields.some(f => f.key === key)
					})
					.map(([key, fieldConfig]) => {
						const originalField = this.allFields.find(f => f.key === key)
						const permissions = fieldConfig.permissions || {
							show: ['*'],
							show_exclude: false
						}
						// Pulisci array ruoli: rimuovi '*' se ci sono ruoli specifici
						if (permissions.show && permissions.show.length > 1 && permissions.show.includes('*')) {
							permissions.show = permissions.show.filter(r => r !== '*')
						}
						return {
							...originalField,
							visible: fieldConfig.visible !== false,
							permissions
						}
					})
			} else if (this.allFields?.length) {
				// Se non c'è configurazione, mostra tutti i campi con permessi default
				this.selectedFields = this.allFields.map(field => ({
					...field,
					visible: true,
					permissions: {
						show: ['*'],
						show_exclude: false
					}
				}))
			}
		},

		cloneField(field) {
			return {
				...field,
				visible: true,
				permissions: {
					show: ['*'],
					show_exclude: false
				}
			}
		},

		removeField(field) {
			const index = this.selectedFields.findIndex(f => f.key === field.key)
			if (index > -1) {
				this.selectedFields.splice(index, 1)
			}
		},

		toggleExpand(field) {
			this.$set(this.expandedFields, field.key, !this.expandedFields[field.key])
		},

		isExpanded(field) {
			return Boolean(this.expandedFields[field.key])
		},

		updateFieldOrder() {
			// Aggiorna ordine se necessario
		},

		addAllFields() {
			const newFields = this.availableFields.map(field => this.cloneField(field))
			this.selectedFields.push(...newFields)
		},

		clearAllFields() {
			this.selectedFields = []
		},

		cleanupRolesArray(permissions, key) {
			// Se ci sono ruoli specifici selezionati, rimuovi '*'
			if (permissions[key] && permissions[key].length > 1 && permissions[key].includes('*')) {
				permissions[key] = permissions[key].filter(r => r !== '*')
			}
			// Se l'array è vuoto, ripristina il default ['*']
			if (!permissions[key] || permissions[key].length === 0) {
				permissions[key] = ['*']
			}
		},

		async saveConfiguration() {
			const configuration = {
				section_settings: {
					hidden: this.sectionSettings.hidden,
					hidden_for_roles: this.sectionSettings.hidden_for_roles,
					hidden_for_roles_exclude: this.sectionSettings.hidden_for_roles_exclude
				},
				fields: this.selectedFields.reduce((acc, field) => {
					acc[field.key] = {
						visible: field.visible !== false,
						permissions: field.permissions
					}
					return acc
				}, {})
			}

			try {
				// Chiave dinamica con suffix _mobile quando prop mobile=true
				const mobileInfix = this.mobile ? '_mobile' : ''
				const effectiveConfigKey = this.mobile
					? this.configKey.replace('fields_totals_configuration', `fields_totals${mobileInfix}_configuration`)
					: this.configKey

				await this.axios.post('settings/', {
					model: this.modelDef,
					[effectiveConfigKey]: configuration
				})

				this.$store.commit('setSnackbar', {
					timeout: 6000,
					text: 'Configurazione totali salvata con successo',
					value: true,
					color: 'success'
				})

				this.$emit('save', configuration)

			} catch (error) {
				console.error('Error saving totals configuration:', error)
				this.$store.commit('setSnackbar', {
					timeout: 6000,
					text: 'Errore nel salvataggio della configurazione',
					value: true,
					color: 'error'
				})
			}
		}
	}
}
</script>

<style scoped>
.field-card {
	transition: all 0.3s ease;
}

.expand-content {
	transition: all 0.3s ease;
	overflow: hidden;
}

.ghost-element {
	background: #BBDEFB !important;
	opacity: 0.5;
}

.chosen-element {
	background: #BBDEFB !important;
	opacity: 0.5;
}

.drag-handle {
	cursor: move;
}

.cursor-pointer {
	cursor: pointer;
}
</style>
